import { RootState } from 'store/rootReducer';

export const customerIdSelector = (state: RootState) => state.User.botAdmin.data.cid;

export const userId = (state: RootState) => state.User.botAdmin.data.uid;

export const accessControlEntitlementSelector = (state: RootState) =>
	state.User.botAdmin.data.access_control_entitlement;

export const exportbroadcastLevelAnalytics = (state: RootState) =>
	state.User.botAdmin.data.export_broadcast_level_analytics;

export const isMessageSearchEnabled = (state: RootState) => state.User.botAdmin.data.is_message_search_enabled;

export const isRecentMessageFirstSort = (state: RootState) => state.User.botAdmin.data.enable_recent_message_first_sort;

export const categoriesData = (state: RootState) => state.User.categoriesMap;

export const botAdminValue = (state: RootState) => state.User.botAdmin.data;

export const userName = (state: RootState) => state.User.profile.data.name;

export const phoneNumberSelector = (state: RootState) => state.User.profile.data.userPhoneNumber;

export const editAllowedForAdditionalAttr = (state: RootState) =>
	state.User.security.data.is_agent_edit_custom_attributes;

export const isEngatiBrandSelector = (state: RootState) => state.User.botAdmin.data.is_engati_brand;

export const isReferralCustomerSelector = (state: RootState) => state.User.botAdmin.data.is_referral_customer;

export const expertAssistanceFlagSelector = (state: RootState) =>
	state.User.botAdmin.data.welcome_flags.EXPERT_ASSISTANCE;

export const createdOnSelector = (state: RootState) => state.User.botAdmin.data.createdOn;

export const brandingPlatformNameSelector = (state: RootState) => state.User.botAdmin.data?.branding_platform_name;

export const enableWaSandboxBroadcastTrial = (state: RootState) =>
	state.User.botAdmin.data.enable_wa_sandbox_broadcast_trial;

export const supportEmailOrLinkData = (state: RootState) => state.User.botAdmin.data.support_email;

export const userPhoneNumber = (state: RootState) => state.User.profile.data.userPhoneNumber;

export const currentPlan = (state: RootState) => state.User.botAdmin.data.customerPlan;

export const webhookStatusHeadersEnabledSelector = (state: RootState) =>
	state.User.botAdmin.data.enable_webhook_status_headers;

export const enableMMLite = (state: RootState) => state.User.botAdmin.data.enable_mmlite;

export const enableWaVoice = (state: RootState) => state.User.botAdmin.data.enable_wa_voice;

export const isMultiChannelRetryConfiguredSelector = (state: RootState) =>
	state.User.botAdmin.data.enable_broadcast_multi_channel_retry;
